import Nullstack from 'nullstack';
export default function IconBarcode({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-barcode",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4 7v-1a2 2 0 0 1 2 -2h2"
  }), "   ", Nullstack.element("path", {
    d: "M4 17v1a2 2 0 0 0 2 2h2"
  }), "   ", Nullstack.element("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v1"
  }), "   ", Nullstack.element("path", {
    d: "M16 20h2a2 2 0 0 0 2 -2v-1"
  }), "   ", Nullstack.element("rect", {
    x: "5",
    y: "11",
    width: "1",
    height: "2"
  }), "   ", Nullstack.element("line", {
    x1: "10",
    y1: "11",
    x2: "10",
    y2: "13"
  }), "   ", Nullstack.element("rect", {
    x: "14",
    y: "11",
    width: "1",
    height: "2"
  }), "   ", Nullstack.element("line", {
    x1: "19",
    y1: "11",
    x2: "19",
    y2: "13"
  }), " ");
}